import * as React from 'react';
import { getApiHost } from '../../@shared/util';
import { Box, Divider, IconButton, Tooltip, Typography } from '@mui/material';
import { FlexBoxInline, PageHeaderSx, PrimaryBtnSx} from '../../@shared/templates';
import SettingsTokens from './SettingsTokens';
import { Sizes } from '../../@shared/palette';
import LaunchIcon from '@mui/icons-material/Launch';

const Settings = () => {
  const onOpenSwagger = React.useCallback(() => {
    window.open(`${getApiHost()}/swagger`, "_blank");
  }, []);

  return <Box sx={{ padding: "15px", width: "100%" }}>
    <Box sx={{ ...FlexBoxInline, gap: "10px" }}>
      <Typography sx={PageHeaderSx}>
        Settings
      </Typography>
      <Box sx={{ ...FlexBoxInline, gap: "5px" }}>
        <Tooltip title={"API References"} placement="bottom" arrow>
          <IconButton type="button" sx={{ ...PrimaryBtnSx, p: "5px", border: "none" }} aria-label="Edit" onClick={onOpenSwagger}>
            <LaunchIcon sx={{ fontSize: Sizes.icon }} />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
    <Divider sx={{ marginBottom: "10px", marginTop: "10px" }} />
    <SettingsTokens />
  </Box>
}

export default Settings;
